module.exports = __webpack_public_path__ + "img/etc-new-arrow-down.d247580e.svg";